import { Button, Card } from "@ptsd/uikit";
import { Anchor, Text, View, XStack, YStack } from "tamagui";

import { api } from "~/utils/api";
import { phoneToHuman } from "~/utils/formatters";
import { IconPhone } from "~/component/feature/paywall/icons/icon-phone";
import { useMe } from "~/hooks";
import { track } from "~/hooks/use-track";

export const CallToDoctor = (props: React.ComponentProps<typeof Card>) => {
  const person = useMe();

  const { data } = api.home.getDoctorInfo.useQuery(undefined, {
    enabled: !!person.payedFor,
  });

  if (!data) {
    return null;
  }

  return (
    <Card
      data-id="doctor-notification-card"
      flex={1}
      variant={"borderless"}
      size="sm"
      rounded="none"
      justifyContent="space-between"
      alignItems="center"
      backgroundColor={"$gray-50"}
      $gtSm={{
        flexDirection: "row",
        paddingVertical: "$2",
        size: "md",
        rounded: "md",
      }}
      gap={"$3"}
      {...props}
    >
      <XStack
        flex={1}
        alignItems="center"
        width={"auto"}
        gap={"$2"}
        $sm={{
          flexDirection: "column",
          gap: "$1",
        }}
      >
        <YStack width={"auto"} flex={1} gap={"$0.5"} alignItems={"flex-start"}>
          <Card.Title
            data-id="doctor-notification-title"
            color={"$pinkmain-500"}
            $gtSm={{
              textAlign: "left",
              fontSize: "$7",
              lineHeight: "$7",
            }}
            $sm={{
              width: "100%",
              textAlign: "center",
              fontSize: "$6",
              lineHeight: "$6",
            }}
          >
            Давайте покращимо ваш психологічний стан разом
          </Card.Title>
        </YStack>
      </XStack>
      <YStack gap={"$1"}>
        <Anchor
          href={"tel:" + data.phoneNumber}
          textDecorationLine="none"
          data-id="doctor-call-link"
          asChild
        >
          <Button
            flex={1}
            minWidth={200}
            size="md"
            onPress={() => {
              track("Click On Appointment Phone Number");
            }}
            rounded="md"
            variant="primary"
          >
            <View
              flex={1}
              flexDirection={"row"}
              justifyContent={"center"}
              alignItems={"center"}
              gap={"$1"}
            >
              <IconPhone /> {phoneToHuman(data.phoneNumber)}
            </View>
          </Button>
        </Anchor>
        <Text
          fontFamily={"$body"}
          $gtSm={{ display: "block" }}
          display={"none"}
        >
          Зателефонувати в “{data.title}”
        </Text>
      </YStack>
    </Card>
  );
};
